import { createSelector } from '@ngrx/store';
import {
	getSelectedRailroad,
	getRailroadDetailState,
} from '../../+state/railroad-detail.selectors';
import { BASE_64_PREFIX, DEFAULT_TRAIN_IMG_PATH } from 'src/shared/constants';

export const getSelectedRailroadLogo = createSelector(
	getSelectedRailroad,
	(railroad) =>
		railroad && railroad.logo
			? BASE_64_PREFIX + railroad.logo
			: DEFAULT_TRAIN_IMG_PATH
);

export const getIsLoading = createSelector(
	getRailroadDetailState,
	(state) => state.isLoadingLogo
);

export const getIsDefaultRailroadLogo = createSelector(
	getSelectedRailroadLogo,
	(logo) => logo === DEFAULT_TRAIN_IMG_PATH
);
